import { PropTypes } from 'prop-types';
import React from 'react';

import { numberMap } from './Mappings';

const ItemNum = ({ active, color, handleClick, num }) => {
  const Number = numberMap[`num-${num}`];

  return (
    <div
      className={`item-num ${color} ${active ? 'active' : ''}`}
      onClick={handleClick}
    >
      <Number />
    </div>
  );
};

ItemNum.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
  handleClick: PropTypes.func,
  num: PropTypes.number,
};

export default ItemNum;
